/* Camp Right - mobile sticky buy bar gating.

   The bar used to be shown by CSS alone: sections/crn-hero.liquid sets
   .crn-sticky { display: none } then { display: flex } under 820px, with no
   scroll condition anywhere. So on a phone it sat on screen from page load -
   71px of an 844px viewport, about 8% of every screen, permanently - while the
   real Add to cart button was 1.33 screens further down. This gates it: hidden
   until the inline button has scrolled out of view above the viewport.

   WHY THIS IS A SEPARATE FILE rather than part of assets/crn-pdp.js, the
   natural home: crn-pdp.js is 16.7KB and holds the add-to-cart submit handler.
   The Admin API writes whole files, so folding this in would mean
   re-transmitting all of it and risking a transcription slip in the most
   important function on the store. Loaded from snippets/meta-tags.liquid,
   gated to product pages.

   PROGRESSIVE ENHANCEMENT, and this matters. The CSS only hides the bar when it
   carries data-crn-gated, and that attribute is added here. If this script never
   runs the bar stays visible exactly as before, so a customer is never left
   without a reachable buy button. Do not move the hidden state onto plain
   .crn-sticky.

   WHY A SCROLL HANDLER AND NOT IntersectionObserver. IO is the textbook tool
   here and the first version used it. It was abandoned for two reasons. First,
   robustness: IO callbacks are delivered off the rendering loop, and in a
   throttled or background tab they may not arrive - a freshly created observer
   in the build environment received zero callbacks after a real 500px scroll,
   which would leave the bar permanently hidden. Second, a scroll handler doing
   one getBoundingClientRect is genuinely cheap, and it is synchronous, so the
   state is always correct and always testable. There is deliberately no
   requestAnimationFrame throttle either - an earlier component in this theme
   used the usual rAF-plus-flag idiom and froze permanently the first time a
   frame was dropped, because the flag never cleared. */
(function () {
  'use strict';

  var pairs = [];

  function refresh() {
    for (var i = 0; i < pairs.length; i++) {
      var bar = pairs[i].bar;
      var atc = pairs[i].atc;
      /* Show only once the inline button has passed ABOVE the viewport. The
         bottom <= 0 test matters: without it the bar would also show while the
         button is still below the fold on the way down. */
      var scrolledPast = atc.getBoundingClientRect().bottom <= 0;
      if (scrolledPast) {
        bar.classList.add('is-shown');
      } else {
        bar.classList.remove('is-shown');
      }
    }
  }

  function setup() {
    var bars = document.querySelectorAll('.crn-sticky');

    for (var i = 0; i < bars.length; i++) {
      var bar = bars[i];
      if (bar.getAttribute('data-crn-sticky-init')) continue;

      var root = (bar.closest && bar.closest('[data-crn-hero]')) || document;
      var atc = root.querySelector('[data-crn-atc]') || root.querySelector('.crn-atc');

      /* Nothing to compare against: leave the bar alone and always visible
         rather than gate it blind. */
      if (!atc) continue;

      bar.setAttribute('data-crn-sticky-init', '1');
      bar.setAttribute('data-crn-gated', '');
      pairs.push({ bar: bar, atc: atc });
    }

    if (pairs.length) refresh();
  }

  function boot() {
    setup();
    window.addEventListener('scroll', refresh, { passive: true });
    window.addEventListener('resize', refresh);
    window.addEventListener('orientationchange', refresh);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme editor re-renders the section without a page load. */
  document.addEventListener('shopify:section:load', function () {
    pairs = [];
    setup();
  });
})();